import { lazy } from 'react';
import { Route } from "react-router";
const ManagerActsPage = lazy(() => import("./ManagerActsPage"))

export default (<Route component={ManagerActsPage} />)